import React from 'react';
import Layout from './Layout/layout';

const App = () => {
  return (
    <>
      <Layout/>
    </>
  );
}

export default App;
